import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IContactFormProps } from "../../interfaces/common/contactus";
import { IError } from "../../interfaces/user/errors";
import { AppDispatch } from "../../store";
import { toast } from "react-toastify";
import { contactUs } from "../../data-access/apis/common/contact";
import { resetContact } from "../../stores/contact-slice";

const contactFormProps: IContactFormProps = {
    name: '',
    email: '',
    comment: '',
}

export const ContactUsHelper = () => {
    // State for managing the checked status of the checkbox for password criteria.
    // const [isChecked, setIsChecked] = useState(false);
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const account = useSelector((state: any) => state.contact);
    const dispatch: AppDispatch = useDispatch();
    // Initialize errors state with an empty object for each field
    const [formErrors, setFormErrors] = useState<IError[]>([]);
    const [values, setValues] = useState<IContactFormProps>(contactFormProps);
    const navigate = useNavigate(); // Initialize navigate from useNavigate

    // this is validation for every field is empty
    const isFieldEmpty = (field: string) => {
        return field.trim() === '';
    };

    // this is validation for email
    const validateEmail = (email: string): IError | null => {
        if (isFieldEmpty(email)) {
            return { field: 'email', message: 'Please Provide An Email.' };
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            return { field: 'email', message: 'Please enter a valid email address.' };
        } else if (!email.endsWith('gmail.com')) {
            return { field: 'email', message: 'Only Gmail addresses are allowed.' };
        }

        return null; // Return null if email is valid
    };

    const validatecomment = (comment: string): IError | null => {
        if (isFieldEmpty(comment)) {
            return { field: 'comment', message: 'Please Provide Your comment.' };
        } else if (comment.length <= 25) {
            return { field: 'comment', message: 'comment must be more than 25 characters long.' };
        }
        return null; // Return null if comment are valid
    };

    const handleContactus = async (e: React.FormEvent | any) => {
        e.preventDefault();

        // Reset form errors before validation
        const errors: IError[] = [];

        // Validate name field
        if (isFieldEmpty(values.name)) {
            errors.push({ field: 'name', message: 'Please Provide Your Name.' });
        }

        // Validate email field
        const emailError = validateEmail(values.email);
        if (emailError) {
            errors.push(emailError);
        }

        // Validate comment field
        const commentError = validatecomment(values.comment);
        if (commentError) {
            errors.push(commentError);
        }

        // Update form errors state and only proceed if there are no errors
        setFormErrors(errors);

        if (errors.length === 0) {
            setIsProcessing(true);
        } else {
            // Show toast messages for each error
            errors.forEach((error) => {
                toast.error(`${error.message}`, {
                    position: 'bottom-right', // You can customize the toast position
                    autoClose: 3000, // Specify how long the toast should be displayed (in milliseconds)
                });
            });
            return; // Exit early if there are errors
        }

        try {
            if (errors.length === 0) {
                await dispatch(contactUs(values));
            }
        } catch (error: any) {
            toast.error(`${account.errors}`, {
                position: 'bottom-center',
                autoClose: 2000,
            });
        } finally {
            setIsProcessing(false);
            setValues(contactFormProps);  // Reset the form fields
        }
    };


    // Effect hook to dispatch action when form is submitted and there are no errors
    useEffect(() => {
        if (account.statusCode === 200) {
            setIsProcessing(false);
            setValues(contactFormProps);  // Reset the form fields
            navigate('/');
            dispatch(resetContact());
        }
    }, [account.statusCode, navigate, dispatch])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setValues((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    return {
        values,
        formErrors,
        handleContactus,
        isProcessing,
        handleChange
    };

}